// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__10ttD","icon":"SortAdornment_icon__2-r3X","up":"SortAdornment_up__2s2-3","down":"SortAdornment_down__2H_wd","active":"SortAdornment_active___lr4D"};